<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Special Attention (SAA)</h3>

    <div v-if="_gAuth.isAppSas()">
    <div v-if="tableData.length > 0" class="rounded-bottom">
      <el-table
        :data="tableData"
        show-summary
        :summary-method="getSummaries"
        style="width: 100%"
      >
        <el-table-column
          prop="commitment_approved_date"
          label="Detected Status"
          min-width="150"
          width="auto"
        >
          <template slot="header" slot-scope="scope">
            <span class="text-break">{{ scope.column.label }}</span>
          </template>
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.commitment_approved_date }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="commitment_loan_statue"
          label="Facility"
          min-width="150"
          width="auto"
        >
          <template slot="header" slot-scope="scope">
            <span class="text-break">{{ scope.column.label }}</span>
          </template>
          <template slot-scope="{ row }">
            <p class="top-line">
              {{
                row.commitment_is_manual == 1
                  ? row.commitment_loan_statue
                  : row.commitment_sub_items[0].commitment_loan_statue
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column
          prop="commitment_is_special_attention"
          label="Detected A/C No."
          min-width="150"
          width="auto"
        >
          <template slot="header" slot-scope="scope">
            <span class="text-break">{{ scope.column.label }}</span>
          </template>
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.commitment_is_special_attention }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-else class="bg-light p-3 text-center rounded-bottom">
      <p class="text-xs">No SAA recorded</p>
    </div>
    </div>
    <div v-else>
      <!-- Non-SAS App Special Attention Table -->
      <div class="special-attention-table">
        <table class="sa-table" style="width: 100%; border-collapse: collapse; font-size: 13px;">
          <thead>
            <tr>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">No.</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Date</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Sts</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Capacity</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Lender Type</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Facility</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Total Outstanding Balance (RM)</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Date Balance Updated</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Limit/Instl. Amt. (RM)</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Prin. Repmt. Term</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Col Type</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">LGL STS</th>
              <th style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center; background-color: #b3b6b3;">Date Status Updated</th>
            </tr>
          </thead>
          <tbody v-if="hasSpecialAttentionData">
            <tr v-for="(item, index) in normalizedSpecialAttention" :key="index">
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">{{ index + 1 }}</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">{{ item.approved_date || '-' }}</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">{{ item.sts || '-' }}</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">{{ item.capacity || '-' }}</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">{{ item.lender_type || '-' }}</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getSubCommitmentField(item, 'loan_statue') }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ formatAmount(getSubCommitmentField(item, 'curr_outstanding')) }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getSubCommitmentField(item, 'date_balance_updated') }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ formatAmount(getSubCommitmentField(item, 'curr_installment')) }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getSubCommitmentField(item, 'repay_term') }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getSubCommitmentField(item, 'col_type') }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getLegalField(item, 'legal_sts') }}
              </td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">
                {{ getLegalField(item, 'legal_sts_date') }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <!-- Empty row with dashes -->
            <tr>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
              <td style="border: 1px solid #c1c1c1; padding: 6px 8px; text-align: center;">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "SpecialAttentionModal",
  props: {
    specialAttention: {
      type: Array,
      default: () => []
    },
    specialAttentionResp: {
      type: Object,
      default: () => ({})
    },
    show_special_att_full_view: Boolean
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    show: {
      get() {
        return this.show_special_att_full_view;
      },
      set(value) {
        this.$emit("update:show_special_att_full_view", value);
      }
    },
    hasSpecialAttentionData() {
      return this.normalizedSpecialAttention.length > 0;
    },
    
    normalizedSpecialAttention() {
      // Handle both specialAttentionResp and specialAttention props
      if (this.specialAttentionResp && this.specialAttentionResp.mapped_commitments) {
        return this.specialAttentionResp.mapped_commitments;
      }
      if (this.specialAttentionResp && Array.isArray(this.specialAttentionResp)) {
        return this.specialAttentionResp;
      }
      if (this.specialAttention && this.specialAttention.length > 0) {
        return this.specialAttention;
      }
      return [];
    }
  },
  watch: {
    specialAttention: {
      immediate: true,
      handler(val) {
        this.tableData = val && val.length > 0 ? val : [];
      }
    }
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "Total";
          return;
        } else if (index === 2) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    
    // NEW METHOD: Safely access fields from sub_commitment
    getSubCommitmentField(item, fieldName) {
      if (!item || !item.sub_commitment || !Array.isArray(item.sub_commitment) || item.sub_commitment.length === 0) {
        return '-';
      }
      
      // Get the first sub_commitment item
      const subItem = item.sub_commitment[0];
      return subItem[fieldName] || '-';
    },
    
    formatAmount(value) {
      if (!value || value === '' || value === '-') return '-';
      // Convert to number and format with commas
      const num = parseFloat(value);
      if (isNaN(num)) return '-';
      return num.toLocaleString('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
        // NEW: Special method for legal fields which might be in main object
    getLegalField(item, fieldName) {
      if (!item) return '-';
      
      // Try different variations for legal fields
      const fieldVariations = [
        fieldName,
        `legal_${fieldName}`,
        `legal_sts_${fieldName}`,
        `commitment_${fieldName}`,
        `ctos_${fieldName}`,
      ];
      
      for (const variation of fieldVariations) {
        if (item[variation] !== undefined && item[variation] !== null && item[variation] !== '') {
          return item[variation];
        }
      }
      
      return '-';
    },
  },
  // mounted() {
  //   console.log('Mapped commitments:', this.specialAttentionResp.mapped_commitments);
  //   if (this.specialAttentionResp.mapped_commitments && this.specialAttentionResp.mapped_commitments.length > 0) {
  //     const firstItem = this.specialAttentionResp.mapped_commitments[0];
  //     console.log('First mapped commitment:', firstItem);
  //     if (firstItem.sub_commitment && firstItem.sub_commitment.length > 0) {
  //       console.log('First sub commitment loan_statue:', firstItem.sub_commitment[0].loan_statue);
  //       console.log('First sub commitment curr_outstanding:', firstItem.sub_commitment[0].curr_outstanding);
  //       console.log('First sub commitment date_balance_updated:', firstItem.sub_commitment[0].date_balance_updated);
  //     }
  //   }
  // }
};
</script>

<style scoped>
.special-attention-table {
  margin-top: 10px;
}

.sa-table {
  border: 1px solid #c1c1c1;
}

.sa-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center !important;
}

.sa-table td {
  background-color: #fff;
  white-space: nowrap;
}
</style>